function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M233.053,383.365c26.631,19.04,58.066,29.104,90.908,29.104c86.278,0,156.469-70.192,156.469-156.469 S410.238,99.53,323.961,99.53s-156.469,70.192-156.469,156.469c0,38.512,14.117,75.522,39.753,104.214 c3.233,3.618,8.788,3.932,12.409,0.698c3.62-3.234,3.931-8.789,0.698-12.409C197.6,323.037,185.069,290.185,185.069,256 c0-76.586,62.307-138.893,138.893-138.893S462.855,179.414,462.855,256s-62.309,138.893-138.894,138.893 c-29.154,0-57.054-8.93-80.686-25.826c-3.948-2.823-9.436-1.91-12.26,2.038C228.192,375.053,229.104,380.541,233.053,383.365z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.788,347.672c4.853,0,8.788-3.935,8.788-8.788v-245c0-9.944,8.089-18.032,18.032-18.032h381.854 c4.853,0,8.788-3.935,8.788-8.788c0-4.853-3.935-8.788-8.788-8.788H35.608C15.973,58.276,0,74.249,0,93.884v245 C0,343.738,3.935,347.672,8.788,347.672z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M476.392,58.276H447.93c-4.853,0-8.788,3.935-8.788,8.788c0,4.853,3.935,8.788,8.788,8.788h28.462 c9.944,0,18.032,8.089,18.032,18.032v324.232c0,9.944-8.089,18.032-18.032,18.032H35.608c-9.944,0-18.032-8.089-18.032-18.032 v-49.938c0-4.853-3.935-8.788-8.788-8.788S0,363.325,0,368.178v49.938c0,19.635,15.973,35.608,35.608,35.608h440.783 c19.635,0,35.609-15.973,35.609-35.608V93.884C512,74.249,496.027,58.276,476.392,58.276z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M205.525,245.561c-4.853,0-8.788,3.935-8.788,8.788c0,19.221,9.619,36.955,25.732,47.435 c9.353,6.084,20.052,9.177,30.82,9.176c7.779,0,15.594-1.614,22.961-4.882l26.884-11.909c3.287,1.802,6.777,3.166,10.404,4.058 v76.213c0,4.853,3.935,8.788,8.788,8.788c19.211,0,36.937-9.618,47.419-25.727c10.485-16.114,12.097-36.226,4.312-53.795 l-11.907-26.894c1.792-3.279,3.145-6.763,4.036-10.384h76.223c4.853,0,8.788-3.935,8.788-8.788c0-19.219-9.618-36.951-25.728-47.434 c-16.11-10.483-36.217-12.093-53.782-4.309l-26.906,11.913c-3.277-1.794-6.762-3.15-10.384-4.04v-76.224 c0-4.853-3.935-8.788-8.788-8.788c-19.212,0-36.94,9.617-47.421,25.725c-10.483,16.11-12.093,36.219-4.309,53.787l11.905,26.888 c-1.796,3.282-3.154,6.773-4.046,10.401h-76.21V245.561z M269.128,290.01c-12.109,5.37-25.97,4.264-37.074-2.96 c-8.595-5.592-14.511-14.176-16.747-23.913h65.75c1.104,6.597,3.72,12.831,7.593,18.227L269.128,290.01z M355.013,347.917 c-5.59,8.592-14.169,14.505-23.899,16.742v-65.761c6.599-1.106,12.834-3.724,18.228-7.595l8.644,19.523 C363.355,322.94,362.243,336.806,355.013,347.917z M378.803,221.969c12.111-5.367,25.973-4.256,37.079,2.97 c8.595,5.592,14.509,14.177,16.746,23.913h-65.76c-1.105-6.606-3.723-12.844-7.594-18.236L378.803,221.969z M349.898,256.001 c0,0.36-0.006,0.721-0.028,1.072c-0.003,0.055-0.006,0.11-0.009,0.164c-0.228,4.982-1.878,9.753-4.774,13.803 c-4.864,6.82-12.764,10.891-21.131,10.891c-0.359,0-0.71-0.006-1.06-0.028c-0.06-0.004-0.12-0.007-0.179-0.009 c-4.969-0.22-9.735-1.87-13.78-4.771c-0.089-0.063-0.178-0.125-0.268-0.185c-6.67-4.879-10.642-12.682-10.642-20.936 c0-0.366,0.006-0.731,0.028-1.097c0.004-0.05,0.006-0.101,0.008-0.152c0.23-4.993,1.88-9.763,4.785-13.815 c4.858-6.811,12.749-10.88,21.108-10.88c0.362,0,0.724,0.005,1.086,0.028c0.054,0.004,0.108,0.006,0.162,0.009 c4.985,0.229,9.751,1.88,13.809,4.789C345.829,239.737,349.898,247.631,349.898,256.001z M292.918,164.071 c5.59-8.592,14.17-14.504,23.9-16.741v65.759c-6.601,1.104-12.834,3.718-18.227,7.587l-8.644-19.523 C284.581,189.04,285.691,175.178,292.918,164.071z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M139.563,116.275H48.171c-4.853,0-8.788,3.935-8.788,8.788s3.935,8.788,8.788,8.788h91.392c4.853,0,8.788-3.935,8.788-8.788 S144.418,116.275,139.563,116.275z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M139.563,247.213H48.171c-4.853,0-8.788,3.935-8.788,8.788c0,4.853,3.935,8.788,8.788,8.788h91.392 c4.853,0,8.788-3.935,8.788-8.788C148.351,251.148,144.418,247.213,139.563,247.213z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M139.563,334.504H48.171c-4.853,0-8.788,3.935-8.788,8.788c0,4.853,3.935,8.788,8.788,8.788h91.392 c4.853,0,8.788-3.935,8.788-8.788C148.351,338.439,144.418,334.504,139.563,334.504z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M139.563,290.859H48.171c-4.853,0-8.788,3.935-8.788,8.788c0,4.853,3.935,8.788,8.788,8.788h91.392 c4.853,0,8.788-3.935,8.788-8.788C148.351,294.793,144.418,290.859,139.563,290.859z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M139.563,378.15H48.171c-4.853,0-8.788,3.935-8.788,8.788s3.935,8.788,8.788,8.788h91.392c4.853,0,8.788-3.935,8.788-8.788 S144.418,378.15,139.563,378.15z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M139.563,203.567h-9.959c-4.853,0-8.788,3.935-8.788,8.788c0,4.853,3.935,8.788,8.788,8.788h9.959 c4.853,0,8.788-3.935,8.788-8.788C148.351,207.502,144.418,203.567,139.563,203.567z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M48.171,221.144h52.14c4.853,0,8.788-3.935,8.788-8.788c0-4.853-3.935-8.788-8.788-8.788h-52.14 c-4.853,0-8.788,3.935-8.788,8.788C39.383,217.209,43.317,221.144,48.171,221.144z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M139.563,159.921H48.171c-4.853,0-8.788,3.935-8.788,8.788s3.935,8.788,8.788,8.788h91.392c4.853,0,8.788-3.935,8.788-8.788 S144.418,159.921,139.563,159.921z"
});

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var _ref25 = /*#__PURE__*/React.createElement("g", null);

var _ref26 = /*#__PURE__*/React.createElement("g", null);

var _ref27 = /*#__PURE__*/React.createElement("g", null);

var _ref28 = /*#__PURE__*/React.createElement("g", null);

var SvgWaterChiller = function SvgWaterChiller(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M8.788,93.889v324.225c0,14.811,12.011,26.822,26.821,26.822h440.78 c14.811,0,26.822-12.01,26.822-26.822V93.889c0-14.823-12.01-26.822-26.822-26.822H35.61C20.799,67.067,8.788,79.065,8.788,93.889z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4D4D4D"
    },
    cx: 323.967,
    cy: 255.993,
    r: 147.676
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#247396"
    },
    d: "M205.526,254.349c0,34.567,35.563,57.709,67.165,43.695l31.11-13.78 c-8.812-6.292-14.565-16.604-14.565-28.263c0-0.551,0.012-1.101,0.047-1.652H205.526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#247396"
    },
    d: "M322.327,290.673v83.769c34.555,0,57.697-35.574,43.695-67.177l-13.78-31.122 c-6.292,8.823-16.616,14.577-28.286,14.577C323.405,290.72,322.866,290.709,322.327,290.673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#247396"
    },
    d: "M344.11,227.727c8.823,6.281,14.577,16.604,14.577,28.274c0,0.551-0.012,1.101-0.047,1.64h0.012 h83.757c0-34.567-35.563-57.709-67.165-43.707l-31.122,13.78L344.11,227.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#247396"
    },
    d: "M325.608,221.317v-83.769c-34.555,0-57.697,35.563-43.695,67.165l13.78,31.122 c6.292-8.823,16.604-14.565,28.263-14.565C324.506,221.27,325.057,221.282,325.608,221.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#247396"
    },
    d: "M325.608,221.317c-0.551-0.035-1.101-0.047-1.652-0.047c-11.659,0-21.97,5.742-28.263,14.565 c-3.773,5.261-6.093,11.636-6.409,18.514c-0.035,0.551-0.047,1.101-0.047,1.652c0,11.659,5.753,21.97,14.565,28.263h0.012 c5.261,3.773,11.624,6.105,18.514,6.41c0.539,0.035,1.078,0.047,1.629,0.047c11.671,0,21.994-5.753,28.286-14.577 c3.761-5.261,6.081-11.624,6.398-18.502c0.035-0.539,0.047-1.09,0.047-1.64c0-11.671-5.753-21.994-14.577-28.274 C338.848,223.954,332.486,221.634,325.608,221.317z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaterChiller, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/water-chiller.d55a8901.svg";
export { ForwardRef as ReactComponent };